import React from "react";

type Props = {
  title: string;
  link: string;
};

const guidePlayerIcon = ({ title, link }: Props) => {
  return (
    <div
      style={{
        width: "240px",
        height: "150px",
        backgroundColor: "#1E3A8A",
        borderRadius: "10px",
        padding: "7.5px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "10px",

          display: "flex",
          position: "relative",
        }}
      >
        <img
          alt="imag"
          src={link}
          width={"100%"}
          height={"100%"}
          style={{
            borderRadius: "10px",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            backgroundColor: "rgba(62, 89, 125, .8)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: "16%",
              color: "#ffff",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            {title}
          </span>
          <Player />
        </div>
      </div>
    </div>
  );
};

export default guidePlayerIcon;

const Player = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="204" height="124" fill="none" viewBox="0 0 204 124">
    <path
      fill="#FFA116"
      d="M102.5 86.915c10.77 0 19.5-8.712 19.5-19.458C122 56.711 113.27 48 102.5 48S83 56.711 83 67.457c0 10.747 8.73 19.458 19.5 19.458Z"
    />
    <path
      fill="#FEFEFE"
      d="M97.8 73.144V61.66a.733.733 0 0 1 1.096-.637l10.28 5.784a.732.732 0 0 1 0 1.275l-10.28 5.748a.738.738 0 0 1-1.017-.304.733.733 0 0 1-.08-.382ZM1.68 121.795v.545H.727v-.368l.518-1.118a.929.929 0 0 0 .103-.268 1.66 1.66 0 0 0 .04-.345c0-.272-.077-.422-.238-.422-.057-.007-.114.017-.167.069a.642.642 0 0 0-.137.23l-.166-.286c.059-.163.134-.292.218-.377.085-.085.177-.124.27-.113.286 0 .464.313.464.845a2.45 2.45 0 0 1-.06.521c-.036.161-.09.3-.154.405l-.345.75.607-.068Zm2-2.455v3h-.477v-2.473H2.68v-.46l1-.067Zm2.96 2.309h-.38v.691h-.39v-.691H4.68v-.387l1.1-1.922h.43l-1 1.839h.71v-.595h.38v.595h.38l-.04.47Zm179.04-1.309h-176v1h176v-1Z"
    />
    <path fill="#FFA116" d="M64.68 119.34h-55v2h55v-2Z" />
    <path
      fill="#FFA116"
      d="M66.68 120.84c0 .494-.176.978-.506 1.389-.33.411-.798.731-1.346.921a3.569 3.569 0 0 1-1.734.142 3.235 3.235 0 0 1-1.536-.684 2.406 2.406 0 0 1-.82-1.28 2.118 2.118 0 0 1 .17-1.445 2.66 2.66 0 0 1 1.105-1.122 3.437 3.437 0 0 1 1.667-.421c.795 0 1.558.263 2.121.732s.879 1.105.879 1.768Z"
    />
    <path
      fill="#FEFEFE"
      d="M189.68 120.711a.533.533 0 0 1-.077.256.697.697 0 0 1-.202.211.895.895 0 0 1-.293.13 1.045 1.045 0 0 1-.335.029c-.678 0-1.08-.34-1.08-.966a.71.71 0 0 1 .037-.399.873.873 0 0 1 .257-.347c.119-.099.264-.176.426-.225.162-.049.336-.068.509-.057.225-.005.447.039.643.125l-.161.268a1.165 1.165 0 0 0-.482-.089c-.459 0-.758.223-.758.662a.91.91 0 0 1 .304-.16c.115-.035.238-.051.362-.046a.968.968 0 0 1 .322.027.82.82 0 0 1 .279.128c.08.057.144.127.187.205a.491.491 0 0 1 .062.248Zm-.448 0c0-.206-.195-.331-.494-.331a.585.585 0 0 0-.182.014.514.514 0 0 0-.161.068.39.39 0 0 0-.113.112.291.291 0 0 0-.049.137c0 .179.184.322.517.322a.53.53 0 0 0 .34-.043.392.392 0 0 0 .125-.097.307.307 0 0 0 .063-.128l-.046-.054Zm.448-1.075a.182.182 0 0 1 .032-.115.307.307 0 0 1 .106-.098.553.553 0 0 1 .161-.064.756.756 0 0 1 .191-.019.83.83 0 0 1 .194.019.61.61 0 0 1 .165.063.35.35 0 0 1 .112.098.207.207 0 0 1 .039.116c0 .082-.054.16-.15.217a.707.707 0 0 1-.36.091.76.76 0 0 1-.192-.024.56.56 0 0 1-.161-.067.327.327 0 0 1-.105-.1.19.19 0 0 1-.032-.117Zm0 1.396a.184.184 0 0 1 .032-.115.307.307 0 0 1 .106-.098.582.582 0 0 1 .161-.064.804.804 0 0 1 .191-.019.83.83 0 0 1 .194.019.61.61 0 0 1 .165.064c.048.027.086.06.112.097a.207.207 0 0 1 .039.116c0 .082-.054.16-.15.218a.717.717 0 0 1-.36.09.76.76 0 0 1-.192-.024.534.534 0 0 1-.161-.067.327.327 0 0 1-.105-.1.188.188 0 0 1-.032-.117Zm1-.688c0-.645.431-1.004.994-1.004.564 0 1.006.359 1.006 1.004 0 .646-.431.996-1.006.996-.574 0-.994-.359-.994-.996Zm1.547 0c0-.475-.221-.69-.553-.69-.331 0-.552.215-.552.69 0 .476.232.682.552.682.321 0 .564-.215.564-.682h-.011Zm.453 0c0-.645.431-1.004.994-1.004.564 0 1.006.359 1.006 1.004 0 .646-.431.996-1.006.996-.574 0-.994-.359-.994-.996Zm1.558 0c0-.475-.232-.69-.564-.69-.331 0-.552.215-.552.69 0 .476.232.682.552.682.321 0 .564-.215.564-.682Zm4.136-.004h-.694v-2h2v.691h-1.306v1.309Zm1.306 3h-2v-2h.694v1.305h1.306v.695Zm4 0h-2v-.695h1.302v-1.305h.698v2Zm0-3h-.692v-1.306h-1.308v-.694h2v2ZM175.835 1.213a5.5 5.5 0 0 1 1.16-.1c.776 0 1.936-.08 3.348-.111h.263v.211c0 1.691 0 3.624.05 5.727v.634l-.454-.453-.605-.604-1.533-1.53h.353l-2.391 2.114-.393.342V6.93c0-1.761.07-3.23.111-4.217a7.876 7.876 0 0 1 .121-1.51s.06.644.111 1.65c.05 1.007.091 2.416.111 4.027l-.384-.171 2.361-2.154.181-.161.172.17 1.543 1.53.595.595-.444.19V1.154l.212.211c-1.321 0-2.421-.07-3.218-.11a9.084 9.084 0 0 1-1.27-.04Zm16.592.714c-.348.485-.722.952-1.119 1.399-.747.905-1.856 2.264-3.208 3.774l-.433.493V3.819l.08.191-2.017-1.942-.444-.433h.615c2.018 0 3.672.11 4.802.17 1.129.061 1.775.091 1.724.112-.05.02-.786 0-1.956.09s-2.734.12-4.57.12l.172-.422 2.017 1.913.081.08v3.231l-.434-.171c1.271-1.39 2.421-2.547 3.268-3.412.848-.866 1.372-1.39 1.422-1.42Z"
    />
    <path
      fill="#FEFEFE"
      d="M192.428 1.928c.06.14-.908.664-2.159 1.187a5.96 5.96 0 0 1-2.35.705 11.464 11.464 0 0 1 4.509-1.892Zm8.089-.715c.264-.072.543-.072.807 0 .74.141 1.405.54 1.876 1.127a3.331 3.331 0 0 1 .545 3.211 3.415 3.415 0 0 1-3.228 2.286 3.424 3.424 0 0 1-3.228-2.286 3.368 3.368 0 0 1-.148-1.674 3.37 3.37 0 0 1 .683-1.537 3.216 3.216 0 0 1 1.886-1.147c.264-.072.543-.072.807 0 0 .05-.282.06-.756.201a3.142 3.142 0 0 0-1.634 1.178 2.95 2.95 0 0 0-.255 3.088 2.969 2.969 0 0 0 5.291 0 2.96 2.96 0 0 0-.255-3.088 3.15 3.15 0 0 0-1.634-1.178c-.495-.12-.757-.13-.757-.18Z"
    />
    <path
      fill="#FEFEFE"
      d="M201.606 5.761c-.1.101-.796-.422-1.553-1.167l-.071-.08v-.162c0-1.067.111-1.932.263-1.932.151 0 .262.865.262 1.932l-.081-.18c.757.794 1.281 1.489 1.18 1.59ZM112.281 4.55c0 .152-22.02.262-49.173.262-27.153 0-49.182-.11-49.182-.261 0-.151 22.019-.262 49.182-.262 27.164 0 49.173.12 49.173.262ZM5.042 8.435A3.88 3.88 0 0 0 8.925 4.56 3.88 3.88 0 0 0 5.042.686 3.88 3.88 0 0 0 1.158 4.56a3.88 3.88 0 0 0 3.884 3.875Z"
    />
  </svg>
);
